import { createFileRoute } from '@tanstack/react-router';
import { FeedbackForm } from '../../../../features/direct-feedback';
import { FORM_ORIGINS } from '../../../../lib/form-origins';

export const Route = createFileRoute('/_auth/admin/feedback/new')({
  component: () => <FeedbackForm origin={FORM_ORIGINS.ADMIN} />,
});
